import React from 'react';
import { WalletGenerator } from './components/WalletGenerator';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <WalletGenerator />
    </div>
  );
};

export default App;
